// @ts-strict-ignore
import { isEmpty } from 'lodash';
import { RRule, Weekday } from 'rrule';

export function matchesWeekday(rule: RRule | undefined, day: Weekday): boolean {
  return (
    !isEmpty(rule) &&
    rule.options.freq === RRule.WEEKLY &&
    rule.options.byweekday.includes(day.weekday)
  );
}
